module.exports = __webpack_public_path__ + "assets/img/in_(2).a9241b30.gif";